import React from 'react';
import { Heading, Skeleton } from '@landr/maestro';

const Title = ({
    content,
    isLoading,
    isMobile,
}: {
    content: string;
    isLoading: boolean;
    isMobile: boolean;
}) => {
    if (isLoading) {
        return (
            <Skeleton
                width="55%"
                height={isMobile ? '36px' : '52px'}
                mt={4}
                mb={18}
            />
        );
    }

    return (
        <Heading as="h3" size={isMobile ? 'xl' : 'xxxl'}>
            {content}
        </Heading>
    );
};

export default Title;
